(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["keeply-pdp-extras"] && !Shopify.designMode) return;
  try {
    /* Poster-Logik: Rahmenfarbe automatisch passend zur Produktart setzen.
     Läuft in der Capture-Phase, also bevor der Variant-Picker die
     ausgewählten Werte liest – so entsteht nie eine ungültige Kombination
     wie "Poster / Black" oder "Framed Poster / No frame". */
  (() => {
    if (window.__kpPosterSync) return;
    window.__kpPosterSync = true;
    const UNFRAMED = ['Poster'];
    const FRAMED = ['Framed Poster', 'Poster mit Rahmen'];
    const NO_FRAME = ['No frame', 'Ohne Rahmen'];
    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || input.type !== 'radio') return;
      const toUnframed = UNFRAMED.includes(input.value);
      const toFramed = FRAMED.includes(input.value);
      if (!toUnframed && !toFramed) return;
      const scope = input.closest('variant-picker') || input.closest('form') || document;
      const radios = Array.from(scope.querySelectorAll('input[type="radio"]'));
      const noFrame = radios.find((r) => NO_FRAME.includes(r.value));
      if (!noFrame) return;
      const colours = radios.filter((r) => r.name === noFrame.name);
      let target = null;
      if (toUnframed && !noFrame.checked) target = noFrame;
      if (toFramed && noFrame.checked) target = colours.find((r) => r !== noFrame) || null;
      if (!target) return;
      colours.forEach((r) => { r.checked = r === target; });
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
